import React from "react";
import SerialNumbersList from "components/serial-numbers/SerialNumbersList";

const SerialNumbers: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Lista Matricole
      </h1>
      <SerialNumbersList />
    </div>
  );
};

export default SerialNumbers;
